export default __webpack_public_path__ + "static/media/魏宏宇.92705047.jpg";